import { z } from "zod";

export const pharmacySchema = z.object({
  pharmacy: z.string().nonempty("Required"),
});

export enum PharmacyType {
  Retail = 8,
  Mail = 1,
}

export const searchSchema = z
  .object({
    name: z.string().optional(),
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    zip: z.string().optional(),
    phone: z.string().optional(),
    serviceLevels: z.nativeEnum(PharmacyType),
  })
  .refine(
    (data) => {
      if (data.serviceLevels === PharmacyType.Mail) {
        return !!data.name;
      }
      return true;
    },
    {
      message: "Name is required for mail order pharmacies",
      path: ["name"],
    },
  )
  .refine(
    (data) => {
      if (data.name) {
        return data.name.length > 2;
      }
      return true;
    },
    {
      message: "Name must be at least 3 characters",
      path: ["name"],
    },
  )
  .refine(
    (data) => {
      if (data.street) {
        return data.street.length > 2;
      }
      return true;
    },
    {
      message: "Street must be at least 3 characters",
      path: ["street"],
    },
  )
  .refine(
    (data) => {
      if (data.serviceLevels === PharmacyType.Retail) {
        return !!data.city || !!data.state || !!data.zip;
      }
      return true;
    },
    {
      message:
        "At least one of city, state, or zip is required for retail pharmacies",
      path: ["city"],
    },
  )
  .refine(
    (data) => {
      if (data.serviceLevels === PharmacyType.Retail && data.zip) {
        return /^\d{5}$/.test(data.zip);
      }
      return true;
    },
    {
      message: "ZIP code must be 5 digits",
      path: ["zip"],
    },
  )
  .refine(
    (data) => {
      if (data.serviceLevels === PharmacyType.Retail && data.phone) {
        return /^\d{10}$/.test(data.phone);
      }
      return true;
    },
    {
      message: "Phone number must be 10 digits",
      path: ["phone"],
    },
  );
